import React, { useContext, useMemo } from 'react';

import { StepupInfo, StepupOffer } from '@wwe-portal/entities/stepup.type';
import { useStepupOffer } from '../lib/use-stepup-offer';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';
interface StepupSourceContextValue {
  stepupInfo: StepupInfo;
  offers: StepupOffer[];
  claimedItems: number;
  availableItems: number;
  launchHistory:
    | {
        launchTimes: number;
        updatedAt: string;
      }
    | undefined
    | null;
}
const StepupSourceContext = React.createContext<StepupSourceContextValue>(
  {} as never
);
export const StepupSourceProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const isAuthenticated = useIsAuthenticated();
  const {
    stepupInfo,
    offers,
    claimedItems,
    availableItems,
    stepupUserLoaded,
    launchHistory,
  } = useStepupOffer();
  const value = useMemo(
    () => ({
      stepupInfo: stepupInfo as StepupInfo,
      offers,
      claimedItems,
      availableItems,
      launchHistory,
    }),
    [stepupInfo, offers, claimedItems, availableItems, launchHistory]
  );
  if (stepupInfo?.stepsUpId == null) return null;
  if (isAuthenticated && !stepupUserLoaded) return null;

  return (
    <StepupSourceContext.Provider value={value}>
      {children}
    </StepupSourceContext.Provider>
  );
};

export const useStepupSourceContext = () => {
  return useContext(StepupSourceContext);
};
